import {takeEvery} from 'redux-saga/effects'

import {
  GET_APPLICATION_FEEDBACK_STATUS,
  SUBMIT_APPLICATION_FEEDBACK,
} from '../../Actions/ApplicationFeedback/ActionTypes/ApiActionType'
import fetchData from '../SagaHelper'

function* applicationFeedbackSagas() {
  yield takeEvery(GET_APPLICATION_FEEDBACK_STATUS, fetchData)
  yield takeEvery(SUBMIT_APPLICATION_FEEDBACK, fetchData)
}

export default applicationFeedbackSagas
